import React, { useEffect, useRef } from 'react';
import { Prompt } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
const UnsavedChangesPrompt = _ref => {
  var _window$MARKET_CONSTA;
  let {
    hasUnsavedChanges
  } = _ref;
  const {
    t
  } = useTranslation();
  const message = t((_window$MARKET_CONSTA = window.MARKET_CONSTANTS) === null || _window$MARKET_CONSTA === void 0 ? void 0 : _window$MARKET_CONSTA.UNSAVED_CHANGES_MESSAGE);
  const hasUnsavedChangesRef = useRef(hasUnsavedChanges);

  // Keep ref in sync with state
  useEffect(() => {
    hasUnsavedChangesRef.current = hasUnsavedChanges;
  }, [hasUnsavedChanges]);

  // Add event listener on mount, remove on unmount
  useEffect(() => {
    const handleBeforeUnload = e => {
      if (hasUnsavedChangesRef.current) {
        e.preventDefault();
      }
    };
    window.addEventListener('beforeunload', handleBeforeUnload);
    return () => window.removeEventListener('beforeunload', handleBeforeUnload);
  }, []);
  return /*#__PURE__*/React.createElement(Prompt, {
    when: hasUnsavedChanges,
    message: message
  });
};
export default UnsavedChangesPrompt;